/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useEffect, useState } from "react";
//#endregion
//#region Styles
import { Row } from "components/styles";
import { 
    TDef, 
    CellTableContentDetails, 
    Field } from "components/CustomTableList/components/TableListItem/ListItem/styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Icons
import PenIcon from "icons/PenIcon";
import TrashIcon from "icons/TrashIcon";
//#endregion
//#region Utils
import {
    HEADERS_TABLE_LIST,
    TAB_KEYS, TAB_VALUES
} from "views/Configuracion/SettingsPenaltyAdmin/utils/constants";
//#endregion

const TableListItemDetails = ({
    item, detailsOfStudentPenaltyIsOpened,
    actions, currentTabIdx
}) => {
    const {
        penalizeDays, resourceModule, 
        library, universitySpace, 
        reasonForPenalize, details
    } = item;
    //#region States
    const [forbiddenActions, setForbiddenActions] = useState(false);
    //#endregion
    //#region Effects
    useEffect(() => {
        setForbiddenActions(getForbiddenActions());
    }, [currentTabIdx]);
    //#endregion
    //#region Functions
    const getForbiddenActions = () => {
        return [
            TAB_KEYS.EXPIRED,
            TAB_KEYS.REMOVED
        ].some(key => TAB_VALUES[key] === currentTabIdx);
    }
    const renderFieldsOfSportsCenter = () => {
        if (!universitySpace) return null;
        return (
            <Field className={classNameField}>
                <span><b>Espacio:</b></span>
                <span>{universitySpace.spaceName}</span>
            </Field>
        );
    }
    const renderFieldsOfLibrary = () => {
        if (!library) return null;
        const { resourceType } = library;
        return (
            <>
                <Field className={classNameField}>
                    <span><b>Recurso:</b></span>
                    <span>{resourceType.name}</span>
                </Field>
                <Field className={classNameField}>
                    <span><b>Motivo:</b></span>
                    <span>{reasonForPenalize.name}</span>
                </Field>
            </>
        );
    }
    const getClassNameField = () => {
        if (!forbiddenActions) return "";
        return ["disabled"].join(" ");
    }
    //#endregion
    const classNameField = getClassNameField();
    return (
        <tr>
            <TDef colSpan={HEADERS_TABLE_LIST.length}>
                <CellTableContentDetails className={detailsOfStudentPenaltyIsOpened && "opened"}>
                    <Row marginLeft="70px" marginRight="70px">
                        <Field className={classNameField}>
                            <span><b>Módulo:</b></span>
                            <span>{resourceModule.name}</span>
                        </Field>
                        {renderFieldsOfLibrary()}
                        {renderFieldsOfSportsCenter()}
                        {penalizeDays !== -1 &&
                            <Field className={classNameField}>
                                <span><b>Días de sanción:</b></span>
                                <span>{penalizeDays} día(s)</span>
                            </Field>}
                        <Field className={classNameField}>
                            <span><b>Detalles:</b></span>
                            <span>{details || "-"}</span>
                        </Field>
                    </Row>
                    <Row
                        justifyContent="flex-end"
                        marginRight="32px"
                        gap="10px">
                        <CustomButton
                            text="Editar"
                            width="110px"
                            icon={<PenIcon />}
                            onClick={() => !forbiddenActions && actions.openUpdatePenaltyStudentDialog(item)}
                            disabled={forbiddenActions} />
                        <CustomButton
                            variant="secondary"
                            text="Eliminar"
                            width="110px"
                            icon={<TrashIcon />}
                            onClick={() => !forbiddenActions && actions.openDeletePenaltyStudentDialog(item)}
                            disabled={forbiddenActions} />
                    </Row>
                </CellTableContentDetails>
            </TDef>
        </tr>
    );
}

export default TableListItemDetails;